<template>
  <b-card>
    <b-tabs class="tab-primary" v-model="tabIndex">
      <can-access v-bind="showTabsReturns">
        <b-tab lazy v-if="(showTabsCreateReturnsASeller)">
          <template #title>
            <div class="tab-title">
              <feather-icon icon="CornerUpLeftIcon" />
              <span> {{$t('Crear devolución')}}</span>
            </div>
          </template>
          <create></create>
        </b-tab>
      </can-access>
      <b-tab lazy v-if="(!isFromWalmart || isWalmartPudoStoreOperator)">
        <template #title>
          <div class="tab-title">
            <feather-icon icon="FileTextIcon" />
            <span> {{$t('Imprimir')}} </span>
          </div>
        </template>
        <print-return />
      </b-tab>
      <!-- <b-tab lazy>
        <template #title>
          <div class="tab-title">
            <feather-icon icon="FileTextIcon" />
            <span> {{$t('Impresos')}} </span>
          </div>
        </template>
        <p class="text-center my-5">Próximamente</p>
      </b-tab> -->
      <can-access v-bind="showTabsReturns">
        <b-tab lazy v-if="showReturnSummariesTab">
          <template #title>
            <div class="tab-title">
              <feather-icon icon="FileTextIcon" />
              <span> {{$t('Manifiesto')}} </span>
            </div>
          </template>
          <list :sourceList="'return'" />
        </b-tab>
      </can-access>
      <b-tab lazy v-if="showReturnPickupTab">
        <template #title>
          <div class="tab-title">
            <feather-icon icon="FileTextIcon" />
            <span> {{$t('Retiros')}} </span>
          </div>
        </template>
        <return-pickups-list />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import Create from './new-return/Create.vue'
import PrintReturn from '../print-returns/PrintReturn.vue'
import List from '../../manifest/List.vue'
import ReturnPickupsList from '../return-pickups/ReturnPickupsList.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'create-return-tabs',
  components: { Create, PrintReturn, List, ReturnPickupsList },
  data() {
    return {
      tabIndex: 0,
      showTabsReturns: {
        permission: 'canTabsReturns',
        module: 'returns',
        allRoles: true,
        section: 'general'
      }
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession'
    }),
    showReturnPickupTab() {
      return this.mySession?.user_access?.show_return_pickup_tab
    },
    showReturnSummariesTab() {
      return this.mySession?.user_access?.show_return_summaries_tab
    },
    lockCreateReturns() {
      return this.mySession?.special_permissions?.includes('lock-create-returns')
    },
    isFromWalmart() {
      return this.mySession?.organization?.id === 7551
    },
    isWalmartPudoStoreOperator() {
      return this.mySession?.special_permissions?.includes('walmart-pudo-store-operator')
    },
    showTabsCreateReturnsASeller() {
      const showReturnTab = this.companyInfo?.data?.company?.company_marketplaces[0]?.marketplace?.customization?.show_return_create_tab_to_sellers === undefined ? true : this.companyInfo?.data?.company?.company_marketplaces[0]?.marketplace?.customization?.show_return_create_tab_to_sellers

      if (this.mySession.role === 'seller') {
        return showReturnTab
      } else {
        return !this.lockCreateReturns
      }
    },
    companyId () {
      if (['seller', 'ecommerce'].includes(this.mySession.role)) {
        return this.mySession.shipper.id
      } else {
        return this.mySession.organization.id
      }
    }
  },
  methods: {
    getCompanyInfo() {
      this.$store.dispatch('fetchService', { name: 'getCompanyInformation', params: {company_id: this.companyId} })
    }
  },
  watch: {
    mySession() {
      if (!['admin'].includes(this.mySession.role)) this.getCompanyInfo()
    }
  }
}
</script>